import React from 'react';
import PropTypes from 'prop-types';
import { Map, List } from 'immutable';

import RxSpinnerComponent from '@Components/Results/utils/rx-spinner.component';
import { config } from '@Constants/rx-ui/constants';
import BarChartFilterControls from './BarChartFilterControls';
import BarChartFilterGroupItem from './BarChartFilterGroupItem';

import './BarChartFilter.scss';

let spinnerId = 0;

export default function BarChartFilter(props) {
  const {
    filter,
    groups,
    onClickGroup,
    isGroupsFetching,
    customFilterConfig,
    commercialSuppliersFilterGroups,
    isCommercialSuppliersFilterGroupsFetching,
    isPreferredSuppliers,
    disableControls = false,
  } = props;
  const userInputOpen = filter.get('userInputOpen');

  if (!groups.count() || (isPreferredSuppliers && isCommercialSuppliersFilterGroupsFetching)) {
    const isFetching = isPreferredSuppliers ? isCommercialSuppliersFilterGroupsFetching || isGroupsFetching : isGroupsFetching;
    return (
      <section className="bar-chart-filter-no-filters-found">
        {/* eslint-disable-next-line no-plusplus */}
        {isFetching && <RxSpinnerComponent autoStart spinnerScale={1} spinnerId={`BarChartFilter-${spinnerId++}`} />}
        No filters were found
      </section>
    );
  }

  const renderFilterItem = (group, disabled = false) => {
    const id = group.get('id');
    return (
      <BarChartFilterGroupItem
        disabled={userInputOpen || disabled}
        onChange={() => onClickGroup(group)}
        group={group}
        key={id}
        customFilterConfig={customFilterConfig}
      />
    );
  };
  const renderPreferredSuppliers = (group) => {
    const groupValues = group.get('values');
    const isSomeSupplierExist =
      groupValues &&
      groupValues.some((selectedGroup) =>
        // eslint-disable-next-line no-shadow
        commercialSuppliersFilterGroups.find((group) => {
          return group.get('id') === selectedGroup.get('title');
        })
      );
    if (groupValues && groupValues.size) {
      return renderFilterItem(group, !isSomeSupplierExist);
    }

    return (
      <div className="bar-chart-filter-no-filters-found" key={group.get('id')}>
        No preferences selected
      </div>
    );
  };

  return (
    <section className="bar-chart-filter">
      {/* eslint-disable-next-line no-plusplus */}
      {isGroupsFetching && <RxSpinnerComponent autoStart spinnerScale={1} spinnerId={`BarChartFilter-${spinnerId++}`} />}
      <ul className="bar-chart-filter-group">
        {groups.take(config.FILTER_MAX_GROUP_COUNT).map((group) => {
          return isPreferredSuppliers ? renderPreferredSuppliers(group) : renderFilterItem(group);
        })}
      </ul>
      {!disableControls && <BarChartFilterControls {...props} />}
    </section>
  );
}

BarChartFilter.propTypes = {
  disableControls: PropTypes.bool,
  filter: PropTypes.instanceOf(Map).isRequired,
  groups: PropTypes.instanceOf(List).isRequired,
  onClickGroup: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
  onClickViewMore: PropTypes.func.isRequired,
  onClickUserInput: PropTypes.func.isRequired,
  canRenderViewMore: PropTypes.bool.isRequired,
  disableUserInputToggler: PropTypes.bool.isRequired,
  disableViewMore: PropTypes.bool.isRequired,
  customFilterConfig: PropTypes.object,
  isGroupsFetching: PropTypes.bool,
  isPreferredSuppliers: PropTypes.bool,
  commercialSuppliersFilterGroups: PropTypes.instanceOf(List),
  isCommercialSuppliersFilterGroupsFetching: PropTypes.bool,
};
